/**
 * How MySuhbat knows who a person is: MyID (the app's face check), OneID, or
 * "client" -- named by a ticket-mode client's own login and verified by
 * neither, which is why that one is drawn as a warning and says which client
 * vouched for them.
 */
const LABELS = { myid: "MyID", oneid: "OneID" };

const ProviderBadge = ({ provider, assertedBy }) =>
  provider === "client" ? (
    <span
      className="ms-badge ms-badge--progress"
      title="Mijoz tizimi loginidan (ticket). MyID/OneID tasdiqlamagan."
    >
      client · {assertedBy || "?"}
    </span>
  ) : (
    <span className="ms-badge ms-badge--neutral">{LABELS[provider] || provider}</span>
  );

export default ProviderBadge;
